export enum NotificationsPivotKeys {
  Unread = "unread",
  Read = "read",
  All = "all"
}
